import { createTheme, responsiveFontSizes } from '@mui/material';
// eslint-disable-next-line import/no-internal-modules
import type {} from '@mui/x-date-pickers-pro/themeAugmentation';

export const theme = responsiveFontSizes(
    createTheme({
        components: {
            MuiTextField: {
                defaultProps: {
                    variant: 'standard',
                },
            },
            MuiFormControl: {
                defaultProps: {
                    variant: 'standard',
                },
            },
            MuiLink: {
                defaultProps: {
                    underline: 'hover',
                },
            },
        },
    }),
);

// color references: https://material-ui.com/customization/color/
